import { useEffect, useCallback } from 'react';
import { mainButton } from '@telegram-apps/sdk-react';

export const useMainButton = (initialParams = {}, onClick) => {

  const button = mainButton;

  const updateMainButton = useCallback((newParams = {}) => {
    if (button.setParams.isAvailable()) {
      button.setParams({
        text: newParams.text ?? '',
        backgroundColor: newParams.backgroundColor ?? '#FECA1F',
        textColor: newParams.textColor ?? '#0A0A0B',
        isVisible: newParams.isVisible ?? true,
        isEnabled: newParams.isEnabled ?? true,
      });
    }
  }, []);

  useEffect(() => {
    updateMainButton(initialParams); // теперь точно не будет undefined

    let off;
    if (button.onClick.isAvailable() && typeof onClick === 'function') {
      off = button.onClick(onClick);
    }

    return () => {
      if (button.setParams.isAvailable()) {
        button.setParams({ isVisible: false });
      }
      if (off) off();
    };
  }, [initialParams, onClick, updateMainButton]);

  return { updateMainButton };
};
